module.exports = __webpack_public_path__ + "img/edit-button.c400ab7f.svg";